import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { toast } from 'sonner';
import { useApp } from '../context/AppContext';
import PhoneFrame from '../components/PhoneFrame';
import StarField from '../components/StarField';
import { GalaxyMark } from '../components/OrbitLogo';

const messages = {
  reaction: 'starred your broadcast',
  friend_add: 'added you to their orbit',
  galaxy_add: 'added you to a galaxy',
  post_in_galaxy: 'launched a broadcast in your galaxy',
};

export default function Notifications() {
  const nav = useNavigate();
  const {
    notifications,
    notificationsLoading,
    loadNotifications,
    markNotificationReadById,
  } = useApp();

  useEffect(() => {
    loadNotifications().catch((err) => toast(err.message || 'Could not load notifications'));
  }, [loadNotifications]);

  const markRead = async (notification) => {
    if (notification.read) return;
    try {
      await markNotificationReadById(notification.id);
    } catch (err) {
      toast(err.message || 'Could not mark notification read');
    }
  };

  return (
    <PhoneFrame>
      <div className="relative min-h-full">
        <StarField />
        <div className="relative z-10">
          <div className="orbit-page-header">
            <button className="press orbit-icon-button" onClick={() => nav(-1)} aria-label="Go back">
              <ArrowLeft />
            </button>
            <h1 className="font-display orbit-page-title flex-1 text-center">Notifications</h1>
            <div className="w-10" aria-hidden="true" />
          </div>

          <div className="p-4">
            {notificationsLoading && <p className="text-center py-8 italic" style={{ color: '#6f6795' }}>Loading…</p>}
            {!notificationsLoading && notifications.length === 0 && (
              <div className="flex flex-col items-center py-10">
                <div className="floaty mb-3"><GalaxyMark size={44} /></div>
                <p className="text-center italic" style={{ color: '#6f6795' }}>No signals have reached you yet.</p>
              </div>
            )}
            {notifications.map((notification) => {
              const actorName = notification.actor?.name || notification.actor?.handle || 'Orbit';
              return (
                <button
                  key={notification.id}
                  onClick={() => markRead(notification)}
                  className="press orbit-surface-card w-full flex items-center gap-3 mb-3 text-left"
                  style={{ background: notification.read ? 'rgba(20,22,46,.45)' : 'rgba(108,95,191,.2)' }}
                >
                  {notification.actor?.avatar ? (
                    <img src={notification.actor.avatar} alt="" className="w-12 h-12 rounded-full object-cover shrink-0" style={{ border: '1px solid rgba(160,140,230,.4)' }} />
                  ) : (
                    <div className="w-12 h-12 rounded-full flex items-center justify-center font-bold shrink-0" style={{ background: 'linear-gradient(135deg,#ff5bd1,#6b4fd6)', color: '#fff' }}>
                      {actorName[0]?.toUpperCase()}
                    </div>
                  )}
                  <div className="flex-1 min-w-0">
                    <p className="truncate" style={{ color: '#e7dcff' }}>
                      <strong>{actorName}</strong> {messages[notification.type] || 'sent you a signal'}
                    </p>
                    <p className="text-xs mt-1" style={{ color: '#8079a6' }}>
                      {formatDistanceToNow(new Date(notification.createdAt), { addSuffix: true })}
                    </p>
                  </div>
                  {!notification.read && <span className="rounded-full shrink-0" style={{ width: 8, height: 8, background: '#b98cff' }} />}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </PhoneFrame>
  );
}
